// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_Z03","cls2":"FeedbackModal-cls2_hY6 FeedbackModal-cls1_Z03"};